define("shared/components/shared/badge", ["exports", "@ember/component", "@ember/component/template-only", "@ember/template-factory"], function (_exports, _component, _templateOnly, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class={{if @className @className "cVL--badge"}}>
    {{#if (has-block "title")}}
      {{yield to="title"}}
    {{else}}
      {{svg-jar "alpha-label" class="cVL--badge__title is--alpha" desc="Alpha label icon" role="img" title="Alpha Label"}}
      {{svg-jar "beta-label" class="cVL--badge__title is--beta" desc="Beta label icon" role="img" title="Beta Label"}}
    {{/if}}
  
    {{#if @poweredByIcon}}
      <p class="cVL--badge__subtitle">{{t "shared_phrases.powered_by"}}</p>
      {{svg-jar @poweredByIcon class="cVL--badge__title is--poweredBy"}}
    {{/if}}
  
    {{#if (has-block "body")}}
      <p class="cVL--badge__desc">
        {{yield to="body"}}
      </p>
    {{else if @href}}
      <Shared::Link
        @href={{@href}}
        @text={{if @linkText @linkText (t "shared_phrases.learn_more")}}
        class="cVL--badge__link"
      />
    {{/if}}
  </div>
  */
  {
    "id": "X5dwdRYH",
    "block": "[[[10,0],[15,0,[52,[30,1],[30,1],\"cVL--badge\"]],[12],[1,\"\\n\"],[41,[48,[30,5]],[[[1,\"    \"],[18,5,null],[1,\"\\n\"]],[]],[[[1,\"    \"],[1,[28,[35,3],[\"alpha-label\"],[[\"class\",\"desc\",\"role\",\"title\"],[\"cVL--badge__title is--alpha\",\"Alpha label icon\",\"img\",\"Alpha Label\"]]]],[1,\"\\n    \"],[1,[28,[35,3],[\"beta-label\"],[[\"class\",\"desc\",\"role\",\"title\"],[\"cVL--badge__title is--beta\",\"Beta label icon\",\"img\",\"Beta Label\"]]]],[1,\"\\n\"]],[]]],[1,\"\\n\"],[41,[30,2],[[[1,\"    \"],[10,2],[14,0,\"cVL--badge__subtitle\"],[12],[1,[28,[35,4],[\"shared_phrases.powered_by\"],null]],[13],[1,\"\\n    \"],[1,[28,[35,3],[[30,2]],[[\"class\"],[\"cVL--badge__title is--poweredBy\"]]]],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[48,[30,6]],[[[1,\"    \"],[10,2],[14,0,\"cVL--badge__desc\"],[12],[1,\"\\n      \"],[18,6,null],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],[[[41,[30,3],[[[1,\"    \"],[8,[39,5],[[24,0,\"cVL--badge__link\"]],[[\"@href\",\"@text\"],[[30,3],[52,[30,4],[30,4],[28,[37,4],[\"shared_phrases.learn_more\"],null]]]],null],[1,\"\\n  \"]],[]],null]],[]]],[13]],[\"@className\",\"@poweredByIcon\",\"@href\",\"@linkText\",\"&title\",\"&body\"],false,[\"if\",\"has-block\",\"yield\",\"svg-jar\",\"t\",\"shared/link\"]]",
    "moduleName": "shared/components/shared/badge.hbs",
    "isStrictMode": false
  });
  var _default = _exports.default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());
});